/**
 * 常用按钮
 */
export default {
  // 检索
  'find': '',
  // 新增
  'add': 'primary',
  // 编辑
  'edit': 'primary',
  // 删除
  'remove': 'danger',
  // 保存
  'save': 'success',
  // 提交
  'submit': 'success',
  // 撤回
  'cancel': 'warning',
  // 通过
  'pass': 'success',
  // 驳回
  'refuse': 'danger',
  // 导入
  'import': 'primary',
  // 导出
  'export': 'primary',
  // 确定
  'confirm': 'success',
  // 关闭
  'close': 'danger',
  // 返回
  'back': ''
}



// WEBPACK FOOTER //
// ./src/baize/src/Btn.js